import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import EngagementRingsPage from "./pages/EngagementRingsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<EngagementRingsPage />} />
          <Route path="/collections/engagement-rings" element={<EngagementRingsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
